import { Pipe, PipeTransform } from "@angular/core";

import { empleadoTitleCase } from "src/app/_core/utils/empleado-display";

/**
 * Casing de nombre de persona: minúsculas salvo la inicial de cada palabra
 * ("JESUS SANCHEZ" → "Jesus Sanchez"). Reusa la misma lógica que el visor/selector
 * de empleados (`empleadoTitleCase`), para que TODOS los nombres se vean igual en
 * tablas y fichas. No se puede con CSS porque `text-transform: capitalize` no baja
 * las mayúsculas ya existentes.
 *
 * Uso: {{ persona.nombre | nameCase }}
 */
@Pipe({
	name: "nameCase",
	standalone: true,
	pure: true,
})
export class NameCasePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) {
			return value ?? "";
		}
		return empleadoTitleCase(value);
	}
}
